const SCROLL_GUTTER = 30;
const SCROLL_SMOOTHING = 10;
let targetScroll: number;
let timerId: number | undefined = undefined;

/**
 * Auto scrolls the given HTML element
 * @param scrollElement The element to auto-scroll
 * @param scrollRect The element's bounding rectangle
 * @param pageY The current mouse position, this would come from a mouse move or drag event
 */
export function performVerticalAutoScroll(
    scrollElement: HTMLElement,
    scrollRect: ClientRect,
    pageY: number
): void {
    let scrollTop = scrollElement.scrollTop;
    let offset = pageY - scrollRect.top;

    targetScroll = Math.min(scrollTop, scrollTop + offset - SCROLL_GUTTER);
    targetScroll = Math.max(
        targetScroll,
        targetScroll - scrollRect.height + offset + SCROLL_GUTTER
    );

    // scrollTop doesn't respond to negative values, so a negative value will set the scroll in an infinite loop
    targetScroll = Math.max(targetScroll, 0);

    ensureScroll(scrollElement);
}

export function terminateAutoScroll(scrollElement: Element) {
    if (timerId) {
        scrollElement.scrollTop = targetScroll;
        window.clearInterval(timerId);
        timerId = undefined;
    }
}

function ensureScroll(scrollElement: Element) {
    // in some browser sizes/monitor resolutions, the scrollTop and targetScroll values become decimals,
    // which the browser can't set to be exactly equal
    // like scrollElement.scrollTop = 12.945, targetScroll = 13.067
    // to check if the browser is 'close enough', we can just check to see if the values are within 1 pixel
    let samePosition =
        Math.abs(Math.floor(scrollElement.scrollTop) - Math.floor(targetScroll)) <= 1;
    if (!samePosition) {
        if (!timerId) {
            timerId = window.setInterval(() => {
                ensureScroll(scrollElement);
            }, 16);
        } else {
            let diff = Math.ceil(
                Math.abs(targetScroll - scrollElement.scrollTop) / SCROLL_SMOOTHING
            );
            scrollElement.scrollTop += targetScroll > scrollElement.scrollTop ? diff : -diff;
        }
    } else {
        terminateAutoScroll(scrollElement);
    }
}
